import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomerGroupController from "../../../../services/qlts/admissions/customer-group-controller";
import Dropzone from "react-dropzone";
import {getSchoolYear} from "../../../../utils/authority";
import CustomerController from "../../../../services/qlts/admissions/customer-controller";
import FilesApi from "../../../../services/resource/files-api";

class ModalUploadCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: []
        };
    }
    onUploadCustomer = () => {
        if (this.state.files.length < 1){
            toast.warning("Vui lòng chọn file!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }else {
            this.props.showLoading()
            let payload = {
                file: this.state.files,
                yearId: parseInt(getSchoolYear())
            }
            CustomerController.importCustomer(payload, res => {
                let listCustomerError = []
                if (res.success) {
                    if (res.data.customersError.length > 0){
                        toast.success("Đã cập nhật khách hàng!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                        listCustomerError = res.data.customersError
                    }else {
                        toast.success("Cập nhật khách hàng thành công!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                    }
                } else {
                    if (res.message[0] != null){
                        toast.warning(res.message[0], {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                    }else {
                        toast.warning("Định dạng file chưa đúng!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000
                        });
                    }

                }
                this.props.onHide();
                this.props.onRefresh();
                if (listCustomerError.length > 0){
                    this.props.showCustomerError(listCustomerError);
                }
            })
        }
    }

    onFileChange = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    url: res.data.url,
                }, () => {
                    toast.success('Upload thành công!')
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Import Khách hàng</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-md-12 col-xs-12 d-flex mb-2">
                                    <label className="label-item col-md-4 col-xs-12">File đính kèm</label>
                                    <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                              onDrop={acceptedFiles => {
                                                  this.setState({files: acceptedFiles})
                                              }}
                                              multiple={false}>
                                        {({getRootProps, getInputProps}) => (
                                            <section className="container-upload">
                                                <div {...getRootProps({className: 'dropzone'})}>
                                                    <input {...getInputProps()} />
                                                    {files.length > 0 ? <div className="align-center">
                                                        <ul>{files}</ul>
                                                    </div> : <p>Chọn tập tin để upload</p>}
                                                </div>
                                            </section>
                                        )}
                                    </Dropzone>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.onUploadCustomer()}
                                >
                                        <span className='justify-content-center'>
                                            Tải lên
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalUploadCustomer
